import { LanguageType } from 'types';
import { useSurveyContext } from '../components/SurveyContext';

export const SurveyNoVariablesPage = () => {
	const { language } = useSurveyContext();
	const dictionary = DICTIONARY[language];

	return (
		<>
			<div className="flex flex-col p-8 sm:pt-12 md:pt-20 md:w-[756px] mx-auto">
				<div className="flex flex-col gap-4 sm:gap-6 p-4 sm:p-6 bg-white rounded-lg shadow-normal">
					<h1 className="text-2xl sm:text-4xl font-semibold">{dictionary.title}</h1>
					<p className="text-sm sm:text-lg">{dictionary.description}</p>
				</div>
			</div>
		</>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		title: 'The form has no variables',
		description: 'Contact your provider to let them know your form needs to be fixed.'
	},
	[LanguageType.Norwegian]: {
		title: 'Skjemaet har ingen variabler',
		description: 'Kontakt den som sendte deg skjemaet for å få det fikset.'
	}
};
